<div>
  <div mat-card-title>Section wise Revenue</div>
  <div class="mt-2 p-1">
    <nz-table #nzTable [nzData]="sectionWiseRevenue" nzTableLayout="fixed" nzBordered nzShowPagination="false" nzShowSizeChanger
      nzOuterBordered>
      <thead>
        <tr>
          <th class="text-center">Section</th>
          <th class="text-center">Revenue</th>
        </tr>
      </thead>
      <tbody>
        @for (data of nzTable.data; track data) {
          <tr>
            <td>{{data.sectionName}}</td>
            <td class="text-center">{{data.revenue |number}}</td>
          </tr>
        }
      </tbody>
    </nz-table>
  </div>
</div>
